// Incremental Server-Sent-Events parser. We cannot use EventSource because the CRM's auth is
// header-only (EventSource cannot set Authorization), so the page reads a fetch() body and
// feeds it through this.
export function createSseParser(onFrame) {
  let buffer = '';
  let carryCr = false; // a chunk ended in \r; the matching \n may open the next chunk

  function parseFrame(raw) {
    let id = null;
    let type = 'message';
    const data = [];
    for (const line of raw.split('\n')) {
      if (!line || line.startsWith(':')) continue;
      const colon = line.indexOf(':');
      const field = colon === -1 ? line : line.slice(0, colon);
      const value = colon === -1 ? '' : line.slice(colon + 1).replace(/^ /, '');
      if (field === 'id') {
        const n = value.trim() === '' ? NaN : Number(value);
        id = Number.isInteger(n) ? n : null;
      } else if (field === 'event') type = value;
      else if (field === 'data') data.push(value);
    }
    if (!data.length) return; // retry hints and comments carry no data
    let parsed;
    try {
      parsed = JSON.parse(data.join('\n'));
    } catch {
      return; // A malformed frame is dropped; it must not stop the stream.
    }
    onFrame({ id, type, data: parsed }); // outside the try: handler errors must surface
  }

  return {
    push(chunk) {
      let text = (carryCr ? '\r' : '') + chunk;
      carryCr = text.endsWith('\r');
      if (carryCr) text = text.slice(0, -1);
      buffer += text.replace(/\r\n/g, '\n');
      let i;
      while ((i = buffer.indexOf('\n\n')) !== -1) {
        const raw = buffer.slice(0, i);
        buffer = buffer.slice(i + 2);
        parseFrame(raw);
      }
    },
  };
}
